import CustomFormRecordEdit from '@/components/common/customform/record/edit/CustomFormRecordEdit.vue';
import AdvanceExpenseRequest from '@/components/applications/advance-expense-request/AdvanceExpenseRequest.vue';

export default {
  name: 'FormRequestList',
  components: { AdvanceExpenseRequest, CustomFormRecordEdit },

  props: {
    data: {
      default: null
    },
    onlyMyRequest: {
      type: Boolean,
      default: false
    },
    formType: {
      type: String,
      default: 'holiday'
    }
  },

  data () {
    return {
      loading: true,
      currentReq: null,
      tableItems: [],
      form: null,
      paging: { limit: 20, page: 1, total: 0, pages: 0 },
      isMounted: false,
      filterValues: {
        userFullName: '',
        statuses: [],
        filter: null,
        companies: []
      }
    };
  },

  computed: {
    paymentMethods () {
      return this.$store.getters.getConfigOptions('advance_expense_payment_methods', this.$i18n.locale);
    },
    tableHeaders () {
      const headers = [];
      if ((this.canViewAll || this.canShow) && !this.onlyMyRequest) {
        headers.unshift({ key: 'user.fullname', label: this.$t('user.name') });
      }

      if (this.formType === 'advance') {
        headers.push({ key: 'contractId', label: this.$t('kpi.contract_id') });
        // Tīrs D365 kods (bez atkāpšanās uz Axapta) grāmatvedības D365 importam, sk. HR-445.
        headers.push({ key: 'employeeD365Code', label: this.$t('reports.advance-payment.d365-user-id') });
      }

      headers.push({ key: 'created_at', label: this.$t('general.item.created_at'), type: 'date' });
      if (this.formType === 'holiday') {
        headers.push(
          { key: 'fromDate', label: this.$t('custom-form.form-field.HOLIDAY.fromDate'), type: 'date' },
          { key: 'toDate', label: this.$t('custom-form.form-field.HOLIDAY.toDate'), type: 'date' }
        )
      }
      headers.push({ key: 'record.form.name', type: 'slot', slotcode: 'name' });
      if (this.formType === 'benefit') {
        // headers.push({ key: 'id', label: this.$t('applications.benefit.comments'), type: 'slot', slotcode: 'benefitComments' });
      }
      if (this.formType === 'advance') {
        headers.push({ key: 'payout_type', label: this.$t('applications.advance.payout-type'), format: 'formatFromConfig', configKey: 'custom_form_constants', configParam: 'name' });
        headers.push({ key: 'amount', label: this.$t('applications.advance.amount'), format: 'formatDecimal', precision: 2 });
      }
      if (this.formType === 'advance-expense') {
        headers.push({ key: 'code', label: this.$t('applications.advance-expense.number') });
        headers.push({ key: 'period_start', label: this.$t('applications.advance-expense.period'), type: 'slot', slotcode: 'period' });
        headers.push({ key: 'amount', label: this.$t('applications.advance-expense.record-amount'), format: 'formatDecimal', precision: 2 });
        headers.push({ key: 'request_total_amount', label: this.$t('applications.advance-expense.request-total-amount'), format: 'formatDecimal', precision: 2 });
      }
      if (!this.onlyMyRequest && this.formType !== 'advance-expense') {
        headers.push({ key: 'record.approvals', label: this.$t('custom-form.form-field.HOLIDAY.approvals') });
      }
      if (this.formType === 'advance-expense') {
        headers.push({
          key: 'record.status_id',
          label: this.$t('applications.advance-expense.record-status'),
          format: 'formatFromConfig',
          configKey: 'custom_form_record_statuses',
          configParam: 'name',
          filterKey: 'statuses'
        });
        headers.push({
          key: 'status_id',
          label: this.$t('applications.advance-expense.status'),
          format: 'formatFromConfig',
          configKey: 'advance_expense_request_statuses',
          configParam: 'name',
          filterKey: 'expense_statuses'
        });
      } else {
        headers.push({
          key: 'record.status_id',
          label: this.$t('custom-form.form-field.HOLIDAY.status_id'),
          format: 'formatFromConfig',
          configKey: 'custom_form_record_statuses',
          configParam: 'name',
          filterKey: 'statuses'
        });
      }

      const actions = [];
      actions.push({
        ifconfig: { useFunc: true, func: this.canShowViewButton },
        label: this.formType !== 'advance-expense' ? this.$t('custom-form.record.action.view') : this.$t('applications.advance-expense.action-view'),
        emit: 'editItem',
        bicon: 'eye-fill',
        class: 'btn-secondary'
      });
      if (this.formType === 'advance-expense') {
        actions.push({
          ifconfig: { useFunc: true, func: this.canFillItemExpenseReport },
          label: this.$t('applications.advance-expense.edit-request'),
          emit: 'editExpenseForm',
          bicon: 'pencil-fill',
          class: 'btn-secondary'
        });
        actions.push({
          ifconfig: { useFunc: true, func: this.canForceApprove },
          label: this.$t('applications.advance-expense.force-approve'),
          emit: 'forceApproveAdvanceExpenseRequest',
          bicon: 'fast-forward-fill',
          class: 'btn-warning'
        });
        actions.push({
          ifconfig: { useFunc: true, func: this.canSendToSupportSystem },
          label: this.$t('Sūtīt uz Support sistēmu'),
          emit: 'sendToSupportSystem',
          bicon: 'book-fill',
          class: 'btn-primary'
        });
        actions.push({
          ifconfig: { useFunc: true, func: this.canDeleteAdvanceExpenseRequest },
          label: this.$t('general.actions.delete'),
          emit: 'deleteAdvanceExpenseRequest',
          bicon: 'trash',
          class: 'btn-danger'
        });
      }
      if (!this.onlyMyRequest) {
        actions.push({
          label: this.$t('custom-form.record.action.download'),
          emit: 'downloadPdf',
          bicon: 'download',
          class: 'btn-download',
          ifconfig: { param: 'record.file', value: null, notCheck: true }
        });
        actions.unshift({
          label: this.$t('custom-form.record.action.reject'),
          emit: 'rejectHoliday',
          bicon: 'x',
          class: 'btn-danger',
          ifconfig: { useFunc: true, func: this.canChangeStatus }
        });
        actions.unshift({
          label: this.$t('custom-form.record.action.approve'),
          emit: 'approveHoliday',
          bicon: 'check-all',
          class: 'btn-primary',
          ifconfig: { useFunc: true, func: this.canChangeStatus }
        });
        actions.unshift({
          label: this.$t('custom-form.record.action.process'),
          emit: 'processedHoliday',
          bicon: 'book-fill',
          class: 'btn-info',
          ifconfig: { useFunc: true, func: this.canMarkProcessed }
        });
        if (this.formType === 'advance-expense') {
          actions.push({
            ifconfig: { useFunc: true, func: this.canChangeAdvanceExpenseStatus },
            label: this.$t('applications.advance-expense.approve-request'),
            emit: 'approveAdvanceExpenseRequest',
            bicon: 'check-all',
            class: 'btn-primary'
          });
          actions.push({
            ifconfig: { useFunc: true, func: this.canChangeAdvanceExpenseStatus },
            label: this.$t('applications.advance-expense.reject-request'),
            emit: 'rejectAdvanceExpenseRequest',
            bicon: 'x',
            class: 'btn-danger'
          });
        }
      }

      headers.push({ key: 'actions', label: '', actions: actions });
      return headers;
    },
    holidayRejectedStatusId () {
      return this.$store.getters.getParamFromConfigByFilter('holiday_request_statuses', 'code', 'REJECTED', 'id');
    },
    holidayApprovedStatusId () {
      return this.$store.getters.getParamFromConfigByFilter('holiday_request_statuses', 'code', 'APPROVED', 'id');
    },
    formTypeCode () {
      if (this.form) {
        return this.$store.getters.getParamFromConfigByFilter('custom_form_types', 'id', parseInt(this.form.type_id), 'code');
      }
      return null;
    },
    tableExpandConfig () {
      return null;
    },
    requestPath () {
      let path = 'custom-form/form/form-requests/list';
      if (this.filterValues.filter) {
        path += '/' + this.filterValues.filter;
        this.BasicHelper.updateFilterValues(this.$route.name, this.filterValues);
      }
      path += '?perPage=' + this.paging.limit + '&page=' + this.paging.page + '&order=created_at,DESC';
      path += '&requestType=' + this.formType;
      return path;
    },

    canViewAll () {
      return this.ApiRequest.userHasPermission('view-all-custom-forms');
    },

    canShow () {
      return this.ApiRequest.userHasPermission('view-custom-forms');
    },

    canShowCompany () {
      return this.ApiRequest.userHasPermission('view-custom-forms-company');
    },
    tableActions () {
      const actions = { download: false };
      if (this.onlyMyRequest === true && this.formType === 'advance') {
        actions.add = { title: this.$t('applications.advance.new') };
      }
      if (this.formType === 'advance-expense') {
        actions.add = { title: this.$t('applications.advance-expense.create-new') };
      }
      return actions;
    },
    applicationStatuses () {
      return this.$store.getters.getConfigOptions('custom_form_record_statuses', this.$i18n.locale);
    },
    advanceExpenseStatuses () {
      // only the top-level statuses are shown as filter pills; the detailed
      // "Support sistēma" sub-statuses (rejected/registered/approved/VG/booking/...)
      // still exist on records but are intentionally not exposed as separate filters
      const filterCodes = ['DRAFT', 'REVIEW', 'CHANGES_NEEDED', 'APPROVED', 'REJECTED', 'SENT_TO_SUPPORT', 'SUPPORT_BOOKED'];
      return this.$store.getters.getConfigOptions(
        'advance_expense_request_statuses', this.$i18n.locale, 'code', filterCodes, false, false, true
      );
    },
    companies () {
      return this.$store.getters.getConfigOptions('user_companies', this.$i18n.locale, 'disabled', '0');
    },
    recordFilterTypes () {
      const options = [{ value: 'MINE', text: this.$t('custom-form.record.filter.mine') }];
      options.push({ value: 'APPROVABLE', text: this.$t('custom-form.record.filter.approved') });
      options.push({ value: 'ATTACHEDAPPLICATIONS', text: this.$t('custom-form.record.filter.ATTACHED-APPLICATIONS') });
      if (this.canViewAll || this.canShow) {
        options.push({ value: 'ALL', text: this.$t('custom-form.record.filter.all') })
      }
      return options;
    },

    tableFilterConfig () {
      const filters = { }
      if (!this.onlyMyRequest) {
        filters.statuses = { type: 'checkbox', label: '', options: this.applicationStatuses, colOnlyFilter: true }
        filters.expense_statuses = { type: 'checkbox', label: '', options: this.advanceExpenseStatuses, colOnlyFilter: true }
        filters.filter = {
          type: 'select',
          label: this.$t('custom-form.record.filter.title'),
          options: this.recordFilterTypes,
          valueField: 'value',
          class: 'col-md-2'
        }
        if (this.canViewAll || this.canShow) {
          filters.userFullName = {
            type: 'text',
            colOnlyFilter: false,
            label: this.$t('user.name'),
            class: 'col-md-2'
          }
        }
        if (this.canShowCompany && (this.formType === 'holiday' || this.formType === 'advance-expense' || this.ApiRequest.userHasPermission('view-advance-payment-requests-all-companies'))) {
          filters.companies = {
            type: 'checkbox',
            label: this.$t('company-structure.company.name'),
            colOnlyFilter: false,
            options: this.companies,
            class: 'col-md-8'
          }
        }
      }
      if (Object.keys(filters).length < 1) {
        return null;
      }

      return filters;
    },

    approvedStatus () {
      return this.$store.getters.getParamFromConfigByFilter('custom_form_record_statuses', 'code', 'APPROVED', 'id');
    },
    isProductionEnvironment () {
      return this.$store.getters.getDataFromConfigWithFilter('environment', null, null) === 'production';
    }
  },
  methods: {
    download (html, exportCols) {
      const path = this.ApiRequest.addGetParamsToPath(this.requestPath, this.filterValues);
      this.$refs.tableview.downloadTableData(path, exportCols);
    },
    // an application becomes a report once the employee saves it with the advance expense type
    isAdvanceExpenseReport (item) {
      return this.formType === 'advance-expense' && (!!item.payment_method_id || !item.record);
    },
    getAdvanceExpenseTitle (item) {
      let title = 'default';
      if (item.payment_method_id) {
        const paymentMethodCode = this.paymentMethods?.find(method => method.value === item.payment_method_id)?.code;
        if (paymentMethodCode === 'BUSINESS_TRIP') {
          title = 'business-trip';
        }
      }
      return this.$t('applications.advance-expense.title-' + title);
    },
    canShowViewButton (item) {
      return true;
    },
    /*
    makeComments (record) {
      let comments = '';
      record.form.type.fields.forEach(el => {
        if (el.typeCode === 'TEXTAREA') {
          comments = comments + el.name.lv + ':<Br />';
          comments = comments + record.fields[el.id] + '<br /><br />';
        }
      })
      return comments;
    },
     */
    updateFilters () {
      this.BasicHelper.updateFilterValues(this.$route.name, this.filterValues);
      this.getTableData();
    },

    canChangeStatus (item) {
      const userId = this.$session.get('userId');
      if (item.record && !item.record.waiting_approval_from) {
        return false;
      }
      // if requestUser is manager of user's division or department
      if (this.managedUserIds?.includes(item.user_id)) {
        // allow if some manager hasnt already approved
        const hasManagerApproved = item.record?.notifications?.filter(notification => notification.approved === 1 && notification.user_mode == '2'); // DecisionUserMode::DIRECT_MANAGER
        if (hasManagerApproved?.length < 1) {
          return true;
        }
      }
      const notificationSentToUser = item.record?.notifications?.filter(notification => notification.completed === 0 && notification.sent_to == userId);
      if (notificationSentToUser?.length > 0) {
        return true;
      }
      return (item.record && item.record.waiting_approval_from === userId)
    },
    canMarkProcessed (item) {
      if (this.formType === 'advance-expense') {
        return false;
      }
      if ((this.ApiRequest.userHasPermission('edit-custom-forms')) &&
        item.record && item.record.status_id == this.approvedStatus
      ) {
        return true;
      }
      return false;
    },

    getTableData () {
      if (this.currentReq) {
        this.currentReq.cancel('changed search query');
      }
      this.loading = true;
      this.currentReq = this.ApiRequest.request(this.requestPath, this.ApiRequest.REQUEST_POST, this.filterValues, (response) => {
        if (response.data) {
          this.tableItems = response.data.records ?? response.data;
          this.managedUserIds = response.data.managed_user_ids;
          this.paging = response.paging;
          this.loading = false;
        }
      });
    },

    editItem (el, newtab = 0) {
      if (this.formType === 'advance-expense' && !el.record) {
        this.$refs.advanceExpenseRequest.showModal(el);
      } else {
        this.$refs.editElFrm.showModal(el);
      }
    },
    editExpenseForm (el) {
      const routeData = this.$router.resolve({
        name: 'menu.forms.advance-expense-request',
        params: {
          id: el.id
        }
      });
      this.$router.push(routeData.href);
    },
    deleteAdvanceExpenseRequest (el) {
      const path = 'advance-forms/expense/' + el.id;
      this.ApiRequest.request(path, this.ApiRequest.REQUEST_DELETE, [], (response) => {
        if (response.error) {
          this.ApiRequest.displayErrorDialog(response, this);
        } else {
          if (response.data == true) {
            this.$store.commit('toastAdd', { context: 'success', message: this.$t('Dzēsts') });
            this.tableItems = this.tableItems.filter(item => item.id != el.id);
          }
          this.getTableData();
        }
      });
    },
    sendToSupportSystem (el) {
      const row = this.tableItems.find(e => (e.id === el.id));
      if (row) {
        row.loading = true;
        this.$refs.tableview.$forceUpdate();
      }
      const path = 'advance-forms/expense/' + el.id + '/send-to-support-system';
      this.ApiRequest.request(path, this.ApiRequest.REQUEST_POST, [], (response) => {
        if (response.error) {
          this.ApiRequest.displayErrorDialog(response, this);
        } else {
          if (response.data == true) {
            this.$store.commit('toastAdd', { context: 'success', message: this.$t('Nosūtīts uz Support sistēmu') });
          } else {
            // the document never reached Support; without this the button looked
            // like it did nothing at all
            this.$store.commit('toastAdd', { context: 'danger', message: this.$t('api.advance-expense.send.failed') });
          }
          this.getTableData();
        }
        if (row) {
          row.loading = false;
        }
      });
    },
    addItem (el) {
      const routeData = this.formType === 'advance-expense'
        ? this.$router.resolve({ name: 'menu.forms.advance-expense-request', params: { id: 'NEW' } })
        : this.$router.resolve({ name: 'menu.user.application-forms', query: { form_type: this.formType } });
      this.$router.push(routeData.href);
    },
    changePage (pageNr) {
      this.paging.page = pageNr;
      this.getTableData();
    },
    downloadPdf (el) {
      el.loading = true;
      this.$refs.tableview.$forceUpdate();
      const path = 'custom-form/form/view/' + el.record.form_id + '/records/view/' + el.record.id + '/download';
      const self = this;
      this.ApiRequest.request(path, this.ApiRequest.REQUEST_DOWNLOAD, [], function (response) {
        if (response.error) {
          self.ApiRequest.displayErrorDialog(response, self);
        }
        el.loading = false;
        self.$refs.tableview.$forceUpdate();
      });
    },
    approveHoliday (el) {
      this.changeStatus(el, 1)
    },
    rejectHoliday (el) {
      this.changeStatus(el, 0)
    },
    changeStatus (el, status) {
      const record = el.record;
      const form = record.form;
      const path = 'custom-form/form/view/' + form.id + '/records/update-status/' + record.id;
      const row = this.tableItems.find(e => (e.id === el.id));
      if (row) {
        row.loading = true;
        this.$refs.tableview.$forceUpdate();
      }
      this.ApiRequest.request(path, this.ApiRequest.REQUEST_POST, { approve: status }, (response) => {
        if (response.error) {
          this.ApiRequest.displayErrorDialog(response, this);
        } else {
          const messageBody = status
            ? 'custom-form.record.change-status-success-approved'
            : 'custom-form.record.change-status-success-rejected';
          this.ApiRequest.displaySuccessDialog(this, this.$t(messageBody), this.$t('custom-form.record.change-status-success-title'));
          row.record.waiting_approval_from = response.data.record.waiting_approval_from;
          row.record.status_id = response.data.record.status_id + '';
          row.record.approvals = response.data.record.approvals;
          if (row) {
            this.$refs.tableview.$forceUpdate();
          }
        }
        row.loading = false;
      });
    },
    processedHoliday (el) {
      const path = 'custom-form/form/change-status/' + el.record.id;
      el.loading = true;
      this.$refs.tableview.$forceUpdate();
      this.ApiRequest.request(path, this.ApiRequest.REQUEST_POST, { status: 'PROCESSED' }, (response) => {
        if (response.error) {
          this.ApiRequest.displayErrorDialog(response, this);
        } else if (response.data) {
          el.record.status_id = response.data.record.status_id + '';
        }
        el.loading = false;
        this.$refs.tableview.$forceUpdate();
      });
    },

    clearFilters () {
      this.filterValues = {
        userFullName: '',
        statuses: [],
        filter: null,
        companies: []
      }
      this.getTableData();
    },
    canFillItemExpenseReport (item) {
      if (item.record) {
        // a report is prepared only for an approved application (PROCESSED: already paid out in Axapta)
        const recordStatus = this.$store.getters.getDataFromConfigWithFilter('custom_form_record_statuses', 'id', item.record.status_id);
        return ['APPROVED', 'PROCESSED'].includes(recordStatus?.code);
      } else if (item.record_data) {
        return true;
      }
    },
    canSendToSupportSystem (item) {
      return item.status_id === this.$store.getters.getDataFromConfigWithFilter('advance_expense_request_statuses', 'code', 'APPROVED')?.id;
    },
    canDeleteAdvanceExpenseRequest (item) {
      return item.status_id === this.$store.getters.getDataFromConfigWithFilter('advance_expense_request_statuses', 'code', 'DRAFT')?.id;
    },
    // Being the approver the report is waiting on is the right to decide - approvers are company
    // heads without edit-custom-forms, so requiring it left them no approve action in the list.
    // The API authorizes the same way: changeStatus() only checks waiting_approval_from.
    canChangeAdvanceExpenseStatus (item) {
      return !!(item && item.waiting_approval_from == this.$session.get('userId'));
    },
    // Testing aid: lets a tester close the whole approval chain without every approver logging in.
    // Kept out of production, where approving is the approvers' own decision - the API refuses it there too.
    canForceApprove (item) {
      if (this.isProductionEnvironment || !this.ApiRequest.userHasPermission('edit-custom-forms')) {
        return false;
      }
      return !!(item && item.waiting_approval_from);
    },
    approveAdvanceExpenseRequest (el) {
      this.changeAdvanceExpenseStatus(el, 1);
    },
    rejectAdvanceExpenseRequest (el) {
      this.changeAdvanceExpenseStatus(el, 0);
    },
    changeAdvanceExpenseStatus (el, status) {
      const messageBody = status
        ? 'applications.advance-expense.change-status-success-approved'
        : 'applications.advance-expense.change-status-success-rejected';
      this.sendAdvanceExpenseRequestAction(el, 'change-status', { approve: status }, messageBody);
    },
    forceApproveAdvanceExpenseRequest (el) {
      this.sendAdvanceExpenseRequestAction(el, 'force-approve', {}, 'applications.advance-expense.change-status-success-approved');
    },
    sendAdvanceExpenseRequestAction (el, action, data, successMessage) {
      const path = 'advance-forms/expense/' + el.id + '/' + action;
      const row = this.tableItems.find(e => (e.id === el.id));
      if (row) {
        row.loading = true;
        this.$refs.tableview.$forceUpdate();
      }
      this.ApiRequest.request(path, this.ApiRequest.REQUEST_POST, data, (response) => {
        if (response.error) {
          this.ApiRequest.displayErrorDialog(response, this);
        } else {
          this.ApiRequest.displaySuccessDialog(this, this.$t(successMessage), this.$t('applications.advance-expense.change-status-success-title'));
        }
        this.getTableData();
        if (row) {
          row.loading = false;
          this.$refs.tableview.$forceUpdate();
        }
      });
    }
  },

  watch: {
    formType: {
      immediate: true,
      handler () {
        this.getTableData();
      }
    }
  },

  mounted () {
    const filterValues = this.BasicHelper.fillFilterValues(this.$route.name, this.filterValues, this.$session);
    if (this.onlyMyRequest) {
      this.filterValues.filter = 'MINE';
    } else if (this.canViewAll) {
      this.filterValues.filter = (filterValues.filter && filterValues.filter !== null) ? filterValues.filter : 'ALL';
      this.filterValues.companies = [this.$store.getters.getParamFromConfig('user_companies', this.$session.get('company_id'), 'code')];
    } else if (this.canShow) {
      this.filterValues = filterValues;
    } else {
      this.filterValues.filter = (filterValues.filter && filterValues.filter !== null) ? filterValues.filter : 'MINE';
    }

    this.getTableData();
    this.isMounted = true;
  }
}
